import APIService from '../../../Services/APIService';
import { Apis } from '../../../Services/app.constants';
import { mapProfileToSelectOption } from './profileListAdapter';
import { computeHasMore } from '../../../components/ui/SearchableSelect/selectUtils';

function extractList(data) {
  if (Array.isArray(data)) return data;
  return data?.list ?? data?.results ?? [];
}

export async function fetchLicenseProfileListPage({ page, pageSize, signal }) {
  const url = `${Apis.licenseProfiles}?next_page=${page}&limit=${pageSize}`;
  const res = await APIService.get(url, signal ? { signal } : {});

  if (res.status !== 200 && res.status !== 201) {
    throw new Error('Failed to load permission profiles');
  }

  const rawList = extractList(res.data);
  const items = rawList.map(mapProfileToSelectOption).filter(Boolean);
  const totalCount = res.data?.count ?? res.count ?? null;

  return {
    items,
    totalCount,
    hasMore: computeHasMore({
      page,
      pageSize,
      itemsLength: items.length,
      totalCount,
    }),
  };
}
